//import type
import { FETCH_MMDRIVERS, FETCH_MMDRIVER } from '../actions/type';
//initial state
const initialState = {
 drivers: [],
 driver: {},
//  driverUpdated: false
}

//export reducer
export default (state = initialState, action) => {
 switch (action.type) {
  case FETCH_MMDRIVERS:
   return {
    ...state,
    drivers: action.payload,
   }
  default:
   return state
 }
}


// WEBPACK FOOTER //
// ./master/jsx/reducers/mmdriver-reducer.js